namespace TabAurous.HR {
    export interface LeavePolicyDetailsRow {
        LeavePolicyDetailId?: number;
        LeavePolicyId?: number;
        LeaveTypeId?: number;
        LeaveTypeCode?: string;
        AllocatedDays?: number;
    }

    export namespace LeavePolicyDetailsRow {
        export const idProperty = 'LeavePolicyDetailId';
        export const localTextPrefix = 'HR.LeavePolicyDetails';
        export const deletePermission = 'HR:LeavePolicy:Delete';
        export const insertPermission = 'HR:LeavePolicy:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:LeavePolicy:Edit';

        export declare const enum Fields {
            LeavePolicyDetailId = "LeavePolicyDetailId",
            LeavePolicyId = "LeavePolicyId",
            LeaveTypeId = "LeaveTypeId",
            LeaveTypeCode = "LeaveTypeCode",
            AllocatedDays = "AllocatedDays"
        }
    }
}
